/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingpricelevelhint3Inputs */

const en_listingpricelevelhint3 = /** @type {(inputs: Listingpricelevelhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shown on your page and helps search engines place you correctly.`)
};

const de_listingpricelevelhint3 = /** @type {(inputs: Listingpricelevelhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Steht auf eurer Seite und hilft Suchmaschinen, euch richtig einzuordnen.`)
};

/**
* | output |
* | --- |
* | "Shown on your page and helps search engines place you correctly." |
*
* @param {Listingpricelevelhint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingpricelevelhint3 = /** @type {((inputs?: Listingpricelevelhint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingpricelevelhint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingpricelevelhint3(inputs)
	return de_listingpricelevelhint3(inputs)
});
export { listingpricelevelhint3 as "listingPriceLevelHint" }